<template>
  <article class="noticeConainer ">
    <div class="container">
      <div class="maxWidth">
        <div class="noticeBox articleBox">
          <h2 class="title">{{ $t("store.event.activity_description") }}</h2>
          <section class="content">
            <ol>
              <li v-for="(item, index) in descriptions" :key="index">{{ item }}</li>
            </ol>
          </section>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed:{
    descriptions(){
      const descriptions = this.dataSheet.description;

      if(!descriptions){
        return []
      }
      return descriptions.split('\n').filter(item => item.trim() !== '');
    },
    ...mapState('signinSheet',['dataSheet'])
  }
}
</script>
